/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import { useForm } from "react-hook-form";
import {
  Box,
  TextField,
  Button,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Stack } from "@mui/system";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useImmer } from "use-immer";

const ChangePd = ({ submitEvent }) => {
  //CSS
  const card = css({
    width: "min(320px, 100vw - 40px)",
    padding: "25px 102px",
    borderRadius: "20px",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.25)",
    margin: "auto",
  });
  const titleHint = css({
    color: "#2b2b2b",
    fontWeight: 500,
    marginBottom: "50px",
  });
  const textInput = css({ width: "100%", backgroundColor: "#f5f5f5" });
  const sendBtn = css({
    padding: "10px 44px",
    backgroundColor: "#009043",
    marginTop: "50px",
  });

  const [state, produce] = useImmer({
    showPwd: false,
    showPwdNew: false,
    showPwdNewAgain: false,
  });
  const { showPwd, showPwdNew, showPwdNewAgain } = state;

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  return (
    <Box css={card}>
      <form onSubmit={handleSubmit(submitEvent)}>
        <Stack alignItems="center">
          <Box css={titleHint}>修改密碼</Box>
          <TextField
            {...register("oldPassword", { required: true })}
            label="請輸入舊密碼："
            variant="outlined"
            css={textInput}
            sx={{ marginBottom: "20px" }}
            size="small"
            type={showPwd ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      produce((draft) => void (draft.showPwd = !showPwd))
                    }
                  >
                    {showPwd ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            {...register("newPassword", {
              required: true,
              pattern: /(?=.*\d)(?=.*[a-zA-Z]).{6,30}/gm,
              validate: { same: (v) => v !== getValues("password") },
            })}
            label="請輸入新密碼："
            variant="outlined"
            css={textInput}
            sx={{ marginBottom: "20px" }}
            size="small"
            type={showPwdNew ? "text" : "password"}
            error={errors.newPassword ? true : false}
            helperText={
              errors.newPassword?.type === "same"
                ? "新舊密碼請勿相同"
                : errors.newPassword?.type === "pattern"
                ? "至少六碼且英數夾雜"
                : ""
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      produce((draft) => void (draft.showPwdNew = !showPwdNew))
                    }
                  >
                    {showPwdNew ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            {...register("newPasswordAgain", {
              required: true,
              validate: { same: (v) => v === getValues("newPassword") },
            })}
            label="請再次輸入新密碼："
            variant="outlined"
            css={textInput}
            size="small"
            type={showPwdNewAgain ? "text" : "password"}
            error={errors.newPasswordAgain ? true : false}
            helperText={
              errors.newPasswordAgain?.type === "same" ? "請確認新密碼" : ""
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      produce(
                        (draft) =>
                          void (draft.showPwdNewAgain = !showPwdNewAgain)
                      )
                    }
                  >
                    {showPwdNewAgain ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button variant="contained" css={sendBtn} type="submit">
            確認修改
          </Button>
        </Stack>
      </form>
    </Box>
  );
};

export default ChangePd;
